<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close"  @click="closeModal"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('common.buy_subscription') }}</h4>
        </template>
        <template v-slot:body>
            <SubscriptionForm v-if="renderForm" :subscription-type-available="subscriptionTypeAvailable" @change="onChangeNewSubscription" :new-subscription-prop="newSubscription"></SubscriptionForm>
            <div class="form-horizontal margin-top-20"  v-if="newSubscription.payment_mode === PAYMENT_MODE.CREDIT_CARD && newSubscription.creditCardCheckout">
                <div class="form-group" >
                    <label for="client_credit_card" class="col-xs-12 col-md-4 control-label">{{ $t('common.credit_card') }}</label>
                    <div class="col-xs-12 col-md-8">
                        <StripeElements  ref="elementsRef"
                                         id="client_credit_card"
                                         :pk="STRIPE_PUBLIC_KEY"
                                         :locale="$i18n.locale"
                                         @token="tokenCreated"></StripeElements>
                    </div>
                </div>
                <div class="form-group" v-if="newSubscription.payment_mode === PAYMENT_MODE.CREDIT_CARD && newSubscription.creditCardCheckout">
                    <label for="price_new_subscription" class="col-xs-12 col-md-4 control-label">{{ $t('common.price') }}</label>
                    <div class="col-xs-12 col-md-8">
                        <p class="form-control-static" id="price_new_subscription">{{getCurrencySymbolFromString(price_currency_credit_card)}}{{price_credit_card}}</p>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               v-if="newSubscription.payment_mode === PAYMENT_MODE.CREDIT_CARD && !newSubscription.creditCardCheckout"
               href=""
               @click.prevent.stop="confirmCreditCardMethod">
                {{ $t('common.next') }}
                <i class="las la-angle-right"></i>
            </a>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               v-if="newSubscription.payment_mode !== PAYMENT_MODE.CREDIT_CARD || newSubscription.creditCardCheckout"
               @click.prevent.stop="purchaseSubscription()">
                <i class="las la-check"></i>
                {{ $t('common.buy_subscription') }}
            </a>
        </template>
    </ModalContainer>
</template>


<script>
    import {getAllSubscriptionsType, purchaseSubscription} from "../../api";
    import SubscriptionForm from "../subscription/SubscriptionForm";
    import {PAYMENT_MODE, STRIPE_PUBLIC_KEY} from "../../common/constants";
    import { StripeElements } from 'vue-stripe-checkout';
    import ModalContainer from "./ModalContainer";
    import i18n from "../../i18n"
    import {Utils} from "@/common/utils";
    export default {
        name: "PurchaseSubscriptionModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            }
        },
        data: () => {
            return {
                price_credit_card: "0.00",
                price_currency_credit_card: "",
                STRIPE_PUBLIC_KEY: STRIPE_PUBLIC_KEY,
                loading: false,
                newSubscription: {
                    type: null,
                    start_date: null,
                    payment_mode: null,
                    creditCardCheckout: false,
                    notify: true
                },
                PAYMENT_MODE: PAYMENT_MODE,
                errorMessage: "",
                subscriptionTypeAvailable: [],
                renderForm: true
            }
        },
        components: {SubscriptionForm, ModalContainer, StripeElements},
        mounted: function () {
            this.getSubscriptionTypes()
        },
        methods: {
            async confirmCreditCardMethod() {
                this.errorMessage = "";

                this.loading = true;
                try {
                    let response = await purchaseSubscription(this.$route.params.id, this.newSubscription.type.id,
                        this.newSubscription.start_date, this.newSubscription.payment_mode, this.newSubscription.notify);

                    this.loading = false;
                    this.client_secret = response.payment_client_secret;
                    this.price_credit_card = response.price_amount;
                    this.price_currency_credit_card = response.price_currency;
                    this.newSubscription.creditCardCheckout = true;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            async tokenCreated (token) {
                this.loading = true;
                let stripe = window.Stripe(STRIPE_PUBLIC_KEY);

                this.token = token;
                const result = await stripe.confirmCardPayment(this.client_secret, {
                    payment_method: {
                        card: {
                            token: token.id
                        },
                    }
                });


                if (result.error) {
                    if (result.error.type === "card_error") {
                        this.errorMessage = result.error.message
                    }
                } else {

                    if (result.paymentIntent.status === "succeeded") {
                        this.successCreateSubscription()
                    }

                }

                this.loading = false;
            },
            successCreateSubscription() {
                this.$emit('success-purchase-subscription');
                this.$route.params.successMessage = i18n.t('components.subscription.creation_success');
                this.renderForm = false;

                this.$nextTick(() => {
                    this.renderForm = true;
                });
            },
            closeModal(){
                this.$emit('close-subscription-modal');
                this.renderForm = false;
                this.newSubscription = {
                    type: null,
                    start_date: null,
                    payment_mode: null,
                    creditCardCheckout: false
                };

                this.$nextTick(async () => {
                    this.renderForm = true;
                    this.subscriptionTypeAvailable = await getAllSubscriptionsType();
                });
            },
            onChangeNewSubscription(newSubscription) {
                this.newSubscription = newSubscription;
            },
            async getSubscriptionTypes() {
                this.subscriptionTypeAvailable = await getAllSubscriptionsType();
            },
            async purchaseSubscription() {
                this.errorMessage = "";
                if (this.newSubscription.payment_mode === PAYMENT_MODE.CREDIT_CARD) {
                    this.$refs.elementsRef.submit()
                } else {
                    this.loading = true;
                    try {
                        await purchaseSubscription(this.$route.params.id, this.newSubscription.type.id,
                            this.newSubscription.start_date, this.newSubscription.payment_mode, this.newSubscription.notify);

                        this.loading = false;

                        this.successCreateSubscription()
                    } catch (e) {
                        this.loading = false;
                        console.log(e)
                    }
                }
            },
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            }
        }
    };
</script>